import React from 'react';

import {Table} from 'semantic-ui-react';
import {Link} from 'react-router-dom';

const OriginOrdersTable = ({code, originsMenu, fetchGetOrderSummary}) => {
  const globalorderSum = {
    'orderNumber': 'TOTAL',
    'NL': 0,
    'FL': 0,
    'DP': 0,
    'DE': 0,
    'DN': 0,
    'total': 0,
  };

  const generateOrderRow = (orders) => {
    const orderRow = {
      'orderNumber': '',
      'NL': 0,
      'FL': 0,
      'DP': 0,
      'DE': 0,
      'DN': 0,
      'total': 0,
    };
    orders.forEach((order) => {
      orderRow.orderNumber = order.pedido_no;
      if (order.destino !== null) {
        orderRow[order.destino] = order.count_destiny;
      }
    });
    orderRow.total = orderRow.NL + orderRow.FL + orderRow.DP + orderRow.DE + orderRow.DN;
    globalorderSum.NL += orderRow.NL;
    globalorderSum.FL += (orderRow.FL + orderRow.DE + orderRow.DN);
    globalorderSum.DP += orderRow.DP;
    globalorderSum.total += orderRow.total;
    return orderRow;
  };

  const orders = [];
  let tempOrders = [];
  for (let i = 0; i < originsMenu.length - 1; i++) {
    if (originsMenu[i].procedencia === code) {
      if (originsMenu[i].pedido_no !== originsMenu[i + 1].pedido_no) {
        tempOrders = [...tempOrders, originsMenu[i]];
        orders.push(generateOrderRow(tempOrders));
        if (i === originsMenu.length - 2) {
          tempOrders = [];
          tempOrders = [...tempOrders, originsMenu[i + 1]];
          orders.push(generateOrderRow(tempOrders));
        }
        tempOrders = [];
      } else {
        tempOrders.push(originsMenu[i]);
        if (i === originsMenu.length - 2) {
          orders.push(generateOrderRow([...tempOrders, originsMenu[i + 1]]));
        }
      }
    }
  }
  orders.push(globalorderSum);

  const handleClickRow = (orderNumber) => {
    if (orderNumber !== 'TOTAL') {
      fetchGetOrderSummary(orderNumber);
    }
  };

  return (
    <Table striped className="interactive">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>PEDIDO</Table.HeaderCell>
          <Table.HeaderCell>NORMAL</Table.HeaderCell>
          <Table.HeaderCell>DEPÓSITO</Table.HeaderCell>
          <Table.HeaderCell>FLOTANTE</Table.HeaderCell>
          <Table.HeaderCell>
            <h4>TOTAL</h4>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {orders.map((origin, index) => (
          <>
            <Table.Row
              key={index}
              onClick={() => {
                handleClickRow(origin.orderNumber);
              }}
            >
              <Table.Cell>
                {origin.orderNumber !== 'TOTAL' ? (
                  <Link
                    to={`/vehiculos/administracion-pedidos/order/${origin.orderNumber}`}
                  >
                    {origin.orderNumber}
                  </Link>
                ) : (
                  <h5> {origin.orderNumber} </h5>
                )}
              </Table.Cell>
              <Table.Cell>{origin.NL}</Table.Cell>
              <Table.Cell>{origin.DP}</Table.Cell>
              <Table.Cell>{origin.FL + origin.DE + origin.DN}</Table.Cell>
              <Table.Cell>{origin.total}</Table.Cell>
            </Table.Row>
          </>
        ))}
      </Table.Body>
    </Table>
  );
};

export default OriginOrdersTable;
